import React from 'react'
import AnalyticsPage from "./AnalyticsPage"

function AnalyticsPageContainer() {
    return (
        <div className="AnalyticsPageContainer">
            <AnalyticsPage/>
        </div>
    )
}

export default AnalyticsPageContainer
